import {
  Component,
  OnInit,
  ViewChild,
  AfterViewInit,
  Input,
  ElementRef,
} from "@angular/core";
import { OnboardingService } from "../shared/service/onboarding.service";
import { OnboardingHRDetail } from "../shared/models/OnboardingHRDetail";
import { MatPaginator } from "@angular/material/paginator";
import { MatTableDataSource } from "@angular/material/table";
import { MatSortHeader, MatSort, MatDialog, Sort } from "@angular/material";
import { Router } from "@angular/router";
import { ToastrService } from "ngx-toastr";
import {
  ConfirmDialogModel,
  ConfirmDialogComponent,
} from "../shared/components/confirm-dialog/confirm-dialog.component";
import { UserService } from "../shared/service/user.service";
import { formatDate } from "@angular/common";

@Component({
  selector: "app-employee-profiles-list",
  templateUrl: "./employee-profiles-list.component.html",
  styleUrls: ["./employee-profiles-list.component.css"],
})
export class EmployeeProfilesListComponent implements OnInit {
  exampl: any;
  result: any;
  empList: OnboardingHRDetail[];
  error: string;
  dataSourceFTE: MatTableDataSource<any>;
  originalDataSourceAll: any;
  locationsList: any[];
  permission: any;
  editEnable: boolean = false;
  deleteEnable: boolean = false;
  lstData: any;
  constructor(
    private _service: OnboardingService,
    public router: Router,
    public dialog: MatDialog,
    private toastr: ToastrService,
    private _userService: UserService
  ) {
    this.empList = [];
    this.lstData = [];
    this.dataSourceFTE = new MatTableDataSource();
  }
  displayedColumns: string[] = [
    "EmpCode",
    "NamePerRecords",
    "DesignationName",
    "DOJ",
    "CadreName",
    "LocationName",
    "Techgroup",
    "Resume",
    "ResumeLastUpdated",
  ];
  @ViewChild(MatPaginator, { static: false }) paginatorFTE: MatPaginator;
  @ViewChild(MatSort, { static: false }) sortFTE: MatSort;
  @ViewChild("input", { static: false }) input: ElementRef;
  check: boolean = false;
  isLoader: boolean = true;

  ngOnInit() {
    this.getEmployeeProfilesList();
    // setTimeout(() => {
    //   this.isLoader = false;
    // }, 1500);
  }

  removeExtraSpaces(str) {
    return str.replace(/\s+/g, "").trim();
  }

  sortData(sort: Sort) {
    var data = this.lstData.slice();
    if (!sort.active || sort.direction == "") {
      this.dataSourceFTE = data;
      return;
    }

    var res = new MatTableDataSource(
      data.sort((a, b) => {
        let isdesc = sort.direction == "desc";
        switch (sort.active) {
          case "EmpCode":
            return compare(a.EmpCode, b.EmpCode, isdesc);
          case "NamePerRecords":
            return compare(a.NamePerRecords, b.NamePerRecords, isdesc);
          case "DesignationName":
            return compare(a.DesignationName, b.DesignationName, isdesc);
          case "LocationName":
            return compare(a.LocationName, b.LocationName, isdesc);
          case "DOJ":
            return sortString(a.DOJ, b.DOJ, isdesc);
          case "Techgroup":
            return compare(a.TechGroupName, b.TechGroupName, isdesc);
          case "CadreName":
            return compare(a.CadreName, b.CadreName, isdesc);
          case "ResumeLastUpdated":
            return compare(a.ResumeLastUpdated, b.ResumeLastUpdated, isdesc);
          default:
            return 0;
        }
      })
    );
    this.dataSourceFTE = res;
    this.dataSourceFTE.paginator = this.paginatorFTE;
  }

  applyFilter(filterValue: string) {
    if (filterValue != "" && filterValue != null) {
      this.dataSourceFTE = new MatTableDataSource(
        this.originalDataSourceAll.filter(
          (res) =>
            (res.NamePerRecords != "" &&
              res.NamePerRecords != null &&
              this.removeExtraSpaces(res.NamePerRecords.toLowerCase()).includes(
                this.removeExtraSpaces(filterValue.toLowerCase())
              )) ||
            (res.EmpCode != "" &&
              res.EmpCode != null &&
              this.removeExtraSpaces(
                res.EmpCode.toString().toLowerCase()
              ).includes(this.removeExtraSpaces(filterValue.toLowerCase())))
          //||
          //(res.CadreName != "" &&
          //  res.CadreName != null &&
          //  this.removeExtraSpaces(res.CadreName.toLowerCase()).includes(
          //    this.removeExtraSpaces(filterValue.toLowerCase())
          //  ))
        )
      );
    } else {
      this.dataSourceFTE = new MatTableDataSource(this.originalDataSourceAll);
    }
    this.dataSourceFTE.paginator = this.paginatorFTE;
    this.dataSourceFTE.sort = this.sortFTE;
    this.lstData = this.dataSourceFTE.data;
  }

  getEmployeeProfilesList() {
    this.isLoader = true;
    this.empList = [];
    this.dataSourceFTE = new MatTableDataSource();
    this._service.getResumeDetails().subscribe(
      (data: OnboardingHRDetail[]) => {
        data =
          data &&
          data
            // .filter(({ EmpStatus }) => EmpStatus === "Active")
            .sort((a, b) => Number(b.EmpCode) - Number(a.EmpCode));
        this.empList = data;
        this.empList.forEach(employee => {
          employee.ResumeLastUpdated = employee.ResumeLastUpdated
            ? (() => {
              let date = employee.ResumeLastUpdated
              let formattedDate = formatDate(date, 'dd-MMM-yyyy HH:mm:ss', 'en-US')             
              return formattedDate 
            })()
            : ''; 
        });

        let carder = [];
        let designation = [];
        data.map((item) => {
          carder.push(item.CadreName);
          designation.push(item.DesignationName);
        });
        this.dataSourceFTE.data = this.empList;
        this.originalDataSourceAll = this.empList;
        this.dataSourceFTE.paginator = this.paginatorFTE;
        this.dataSourceFTE.sort = this.sortFTE;
        this.lstData = this.empList;
        setTimeout(() => {
          this.isLoader = false;
        }, 1500);
      },
      (error) => {
        this.error = error;
        setTimeout(() => {
          this.isLoader = false;
        }, 1500);
      }
    );
  }

  getOfficeViewerUrl(docUrl: string): string {
    return `https://view.officeapps.live.com/op/view.aspx?src=${encodeURIComponent(
      docUrl
    )}`;
  }
}

function sortString(a, b, isdesc) {
  if (isdesc) {
    return new Date(a).getTime() - new Date(b).getTime();
  }
  return new Date(b).getTime() - new Date(a).getTime();
}

function compare(a, b, isdesc) {
  if (a === null) {
    return 1;
  }
  if (b === null) {
    return -1;
  }
  if (a === b) return 0;

  if (isdesc) return a < b ? 1 : -1;
  else return a < b ? -1 : 1;
}

